import moment from "moment";
import { VENDA_ONLINE_LISTA_STATUS } from "@/utils/venda-online";

const MASCARA = "DD/MM/YYYY HH:mm";
const MASCARA_API = "YYYY-MM-DD HH:mm";

export const VENDA_ONLINE_LISTA_ORDEM = Object.keys(VENDA_ONLINE_LISTA_STATUS);

export const periodoDeHoje = (agora = new Date()) => ({
  inicio: moment(agora).startOf("day").format(MASCARA),
  fim: moment(agora).endOf("day").format(MASCARA)
});

export const periodoParaApi = ({ inicio, fim }) => {
  const periodo = {};
  const de = moment(inicio, MASCARA, true);
  const ate = moment(fim, MASCARA, true);
  if (de.isValid()) periodo.inicio = de.format(MASCARA_API);
  if (ate.isValid()) periodo.fim = ate.format(MASCARA_API);

  return periodo;
};

export const deslocarPeriodo = ({ inicio, fim }, sentido) => {
  const de = moment(inicio, MASCARA, true);
  const ate = moment(fim, MASCARA, true);
  if (!de.isValid() || !ate.isValid()) return { inicio, fim };

  const dias = Math.max(1, Math.ceil(ate.diff(de, "days", true)));

  return {
    inicio: de.clone().add(sentido * dias, "days").format(MASCARA),
    fim: ate.clone().add(sentido * dias, "days").format(MASCARA)
  };
};

export const formatPercentual = (valor) => `${String(Number(valor || 0)).replace(".", ",")}%`;
